import React from 'react'

const ErrorText = ({ msg }) => {
    return <p 
    style={{color: "red"}}
    className="text-danger validation-error">{msg}</p>
}

export { ErrorText }